var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocImgRuleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38527 1.6484C5.53219 -0.390551 8.46781 -0.390552 9.61473 1.6484L13.4852 8.52922C14.6101 10.529 13.1649 13 10.8705 13H3.12954C0.835063 13 -0.610079 10.529 0.514816 8.52922L4.38527 1.6484Z",
    fill: "#6B22B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocImgRuleIcon);
export default __webpack_public_path__ + "static/media/doc-img-rule-icon.aec4803c333306805bd54fb9d01d709b.svg";
export { ForwardRef as ReactComponent };